<template>
  <div v-loading="loading"
       class="rank-chart-wrapper">
    <div class="rank-chart--title">广告排名分布</div>
    <div ref="chart" class="rank-chart--chart"></div>
  </div>
</template>

<script>
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "app-ad-keyword-rank-bar",
    props: {
      data: {
        required: true
      },
      loading: {
        type: Boolean,
        default: false,
        required: true
      }
    },
    data() {
      return {
        chart: null,
      }
    },
    watch: {
      data: {
        handler: function (data) {
          if (isMeaningful(data)) {
            if (this.chart) {
              this.renderData(data);
            } else {
              this.cacheData = data;
            }
          } else {
            this.renderData([]);
          }
        }
      }
    },
    mounted() {
      this.renderChart();
      if (this.cacheData) {
        this.renderData(this.cacheData);
        this.cacheData = null;
      }
    },
    methods: {
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          this.chart = this.$echarts.init(chartRef);
          const option = {
            color: ["rgb(0, 153, 255)"],
            tooltip: {
              trigger: 'axis',
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              top: '5%',
              left: '2%',
              right: '2%',
              bottom: '0',
              containLabel: true
            },
            xAxis: {
              axisLabel: {
                color: "#32393d"
              },
              axisLine: {
                lineStyle: {
                  color: "#32393d"
                }
              },
              type: 'category',
              data: [],
              axisTick: {
                alignWithLabel: true
              }
            },
            yAxis: {
              type: 'value',
              position: "left",
              axisLabel: {
                margin: 4,
                formatter: function (e) {
                  let t = Math.abs(e);
                  return t >= 1e4 && t < 1e7 ?
                    t = t / 1e4 + "万" :
                    t >= 1e7 && (t = t / 1e7 + "千万"), t;
                },
                color: "#32393d"
              },
              splitLine: {
                lineStyle: {
                  color: "#e5e9f2"
                }
              },
              axisLine: {
                lineStyle: {
                  color: "#FFF"
                }
              }
            },
            series: [{
              data: [],
              type: 'bar',
              barWidth: 35
            }]
          };
          this.chart.setOption(option);
          window.addEventListener("resize", () => {
            this.chart.resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
          });
        }
      },
      renderData(data) {
        this.chart.setOption({
          xAxis: {
            data: data.map(item => item.name),
          },
          series: {
            data: data.map(item => item.quantity),
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
</style>
